export default __webpack_public_path__ + "static/media/385b77f3f51ee839bfd31ac40978f0f2.geojson";